import React from 'react'

export const CompareValueProps: React.FC = () => {
  return (
    <section className="rate-selection-value-props">
      <h3 className="rate-selection-value-props__title">
        We've helped thousands of people
      </h3>
      <div className="rate-selection-value-props__props">
        <div className="rate-selection-value-props__prop-box --dark">
          <h4 className="rate-selection-value-props__prop-subtitle">
            $1.6 billion
          </h4>
          <p className="rate-selection-value-props__prop-callout">
            IN LOANS FUNDED
          </p>
        </div>
        <div className="rate-selection-value-props__prop-box --light">
          <h4 className="rate-selection-value-props__prop-subtitle">
            Over 10,000
          </h4>
          <p className="rate-selection-value-props__prop-callout">
            LOANS LOCKED
          </p>
        </div>
      </div>
    </section>
  )
}
